import { gatewayApiAgent } from '../../common/api/apiAgents';
import { DashboardPage } from '../../common/api-types/director';

export async function fetchDashboards() {
  const response = await gatewayApiAgent.get<Array<DashboardPage>>(
    '/director/public/v1/dashboards',
  );
  return response.data;
}
